/**
 * This file provides our CSS-in-JS solution coupled with our them and strong
 * typings.
 */
import * as React from "react"
import * as styledComponents from "styled-components"
import { direction } from "./direction"
import { Theme } from "./theme"

export type GlobalStyleComponent = styledComponents.GlobalStyleComponent<
  {},
  Theme
>
export type ThemedStyledProps<P> = P & { theme: Theme }
export type CSSProp =
  | string
  | styledComponents.FlattenInterpolation<styledComponents.ThemeProps<Theme>>
export type CSSObject = styledComponents.CSSObject

// TODO: useTheme
const {
  default: styled,
  css,
  createGlobalStyle,
  keyframes,
  // TODO: revisit this issue when upgrading styled-components to v5
  ThemeContext: StyledContext,
  // ThemeConsumer,
  ThemeProvider: ThemeProvider_,
  withTheme
} = (styledComponents as any) as styledComponents.ThemedStyledComponentsModule<
  Theme
>

const ThemeContext: React.Context<Theme> = StyledContext

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    direction: ${direction};
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
`

const ThemeProvider = ({
  children,
  theme
}: styledComponents.ThemeProviderProps<Theme, Theme>) => {
  const ThemeGlobalStyles = (theme as Theme).globalStyles
  return (
    <ThemeProvider_ theme={theme}>
      <>
        <GlobalStyle />
        <ThemeGlobalStyles />
        {children}
      </>
    </ThemeProvider_>
  )
}

export {
  css,
  createGlobalStyle,
  keyframes,
  ThemeContext,
  // ThemeConsumer,
  ThemeProvider,
  withTheme
}
export default styled
